<template>
  <!-- start navigator -->
  <div class="container ps-lg-5 pe-lg-5 mt-1">
    <div class="row">
      <div class="
          col-12
          d-none d-lg-flex
          justify-content-between
          align-items-center
        ">
        <nav style="--bs-breadcrumb-divider: '>'" aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link class="text-decoration-none router-link" to="/AgenteService">หน้าแรก</router-link>
            </li>
            <li class="breadcrumb-item router-link active">
              ขอหนังสือรับรองการทำงาน
            </li>
          </ol>
        </nav>
      </div>
    </div>
  </div>
  <!-- end navigator -->
  <div class="container-lg">
    <div class="row">
      <!-- Left Menu -->
      <div class="col-left-menu">
        <div class="left-menu">
          <ul class="d-none d-lg-block">
            <Menu />
          </ul>
        </div>
      </div>
      <!-- Left Menu -->
      <!-- Mobile -->
      <div class="
          col-left-menu
          d-flex d-lg-none
          border-bottom
          align-items-center
          border-bottom
          w-100
          pl-3
          pr-3
        " style="background-color: #f2f2f2">
        <div class="icon-back">
          <router-link to="/AgenteService">
            <img src="@/assets/images/arrow-blue.svg" class="w-100" />
          </router-link>
        </div>
        <div class="title ps-md-3 ps-lg-3 d-block d-lg-none text-center w-100"
          style="font-family: DB Heavent; color: #0057a8">
          ขอหนังสือรับรองการทำงาน
        </div>
      </div>
      <!-- Mobile -->
      <div class="col col-content mb-3">
        <div class="d-none d-lg-flex align-items-center border-bottom">
          <div class="icon-back">
            <router-link to="/AgenteService">
              <img src="@/assets/images/arrow-blue.svg" class="w-100" />
            </router-link>
          </div>
          <div class="
              title
              blue-1
              fw-normal
              ps-md-3
              pe-lg-3
              font-family
              d-none d-md-block d-lg-block
            ">
            ขอหนังสือรับรองการทำงาน
          </div>
        </div>
        <div class="border-bottom pb-3 position-relative">
          <div class="mt-4 mt-lg-2">
            <div class="d-flex align-items-center">
              <div class="col-10 blue-1 fs-5 mt-1 font-family">
                ขอหนังสือรับรองการทำงานภาษาไทย
                <img v-if="this.$store.state.REQUEST_CERT.CERT_THI.SUCCEED" src="@/assets/images/checked.svg"
                  class="svg-checked" />
              </div>
              <div class="icon-circle bg-blue-2"
                @click="ChechCreateJob('/FinishCertTH', this.$store.state.REQUEST_CERT.CERT_THI.SUBJOB)">
                <img src="@/assets/images/icon-pencil.svg" class="w-100 p-2" />
              </div>
            </div>
            <div v-if="this.$store.state.REQUEST_CERT.CERT_THI.SUCCEED" class="gary-3 fs-5 fw-normal font-family">
              <div class="ms-4">
                <label>วัตถุประสงค์การขอหนังสือรับรอง</label>
              </div>
              <div style="margin-left: 40px">
                <label>{{ this.$store.state.REQUEST_CERT.CERT_THI.REASON_DTL }}</label>
              </div>
            </div>
          </div>
        </div>
        <div class="border-bottom pb-3 position-relative">
          <div class="mt-4 mt-lg-2">
            <div class="d-flex align-items-center">
              <div class="col-10 blue-1 fs-5 mt-1 font-family">
                ขอหนังสือรับรองการทำงานภาษาอังกฤษ (ไม่ระบุรายได้)
                <img v-if="this.$store.state.REQUEST_CERT.CERT_ENG.SUCCEED" src="@/assets/images/checked.svg"
                  class="svg-checked" />
              </div>
              <div class="icon-circle bg-blue-2"
                @click="ChechCreateJob('/FinishCertEng', this.$store.state.REQUEST_CERT.CERT_ENG.SUBJOB)">
                <img src="@/assets/images/icon-pencil.svg" class="w-100 p-2" />
              </div>
            </div>
            <div v-if="this.$store.state.REQUEST_CERT.CERT_ENG.SUCCEED" class="gary-3 fs-5 fw-normal font-family">
              <div class="ms-4">
                <label>วัตถุประสงค์การขอหนังสือรับรอง</label>
              </div>
              <div style="margin-left: 40px">
                <label>{{ this.$store.state.REQUEST_CERT.CERT_ENG.REASON_DTL }}</label>
              </div>
            </div>
          </div>
        </div>
        <div class="border-bottom pb-3 position-relative">
          <div class="mt-4 mt-lg-2">
            <div class="d-flex align-items-center">
              <div class="col-10 blue-1 fs-5 mt-1 font-family">
                ขอหนังสือรับรองการทำงานภาษาอังกฤษ (ระบุรายได้ของปีนี้ และปีที่แล้ว)
                <img v-if="this.$store.state.REQUEST_CERT.CERT_ENG_2YEAR.SUCCEED" src="@/assets/images/checked.svg"
                  class="svg-checked" />
              </div>
              <div class="icon-circle bg-blue-2"
                @click="ChechCreateJob('/FinishCertEng2Year', this.$store.state.REQUEST_CERT.CERT_ENG_2YEAR.SUBJOB)">
                <img src="@/assets/images/icon-pencil.svg" class="w-100 p-2" />
              </div>
            </div>
            <div v-if="this.$store.state.REQUEST_CERT.CERT_ENG_2YEAR.SUCCEED" class="gary-3 fs-5 fw-normal font-family">
              <div class="ms-4">
                <label>วัตถุประสงค์การขอหนังสือรับรอง</label>
              </div>
              <div style="margin-left: 40px">
                <label>{{ this.$store.state.REQUEST_CERT.CERT_ENG_2YEAR.REASON_DTL }}</label>
              </div>
            </div>
          </div>
        </div>
        <div class="border-bottom pb-3 position-relative">
          <div class="mt-4 mt-lg-2">
            <div class="d-flex align-items-center">
              <div class="col-10 blue-1 fs-5 mt-1 font-family">
                ขอหนังสือรับรองการทำงานภาษาอังกฤษ (ระบุรายได้เฉพาะของปีนี้)
                <img v-if="this.$store.state.REQUEST_CERT.CERT_ENG_1YEAR.SUCCEED" src="@/assets/images/checked.svg"
                  class="svg-checked" />
              </div>
              <div class="icon-circle bg-blue-2"
                @click="ChechCreateJob('/FinishCertEng1Year', this.$store.state.REQUEST_CERT.CERT_ENG_1YEAR.SUBJOB)">
                <img src="@/assets/images/icon-pencil.svg" class="w-100 p-2" />
              </div>
            </div>
            <div v-if="this.$store.state.REQUEST_CERT.CERT_ENG_1YEAR.SUCCEED" class="gary-3 fs-5 fw-normal font-family">
              <div class="ms-4">
                <label>วัตถุประสงค์การขอหนังสือรับรอง</label>
              </div>
              <div style="margin-left: 40px">
                <label>{{ this.$store.state.REQUEST_CERT.CERT_ENG_1YEAR.REASON_DTL }}</label>
              </div>
            </div>
          </div>
        </div>
        <div class="border-bottom pb-3 position-relative">
          <div class="mt-4 mt-lg-2">
            <div class="d-flex align-items-center">
              <div class="col-10 col-lg-12 blue-1 fs-5 mt-1 font-family">
                ขอหนังสือรับรองการทำงานภาษาอังกฤษเพื่อเดินทางไปเข้าร่วมประชุม
                MDRT แบบระบุรายได้ปีก่อนหน้า
                <img v-if="show" src="@/assets/images/checked.svg" class="svg-checked" />
              </div>
              <router-link to="" class="icon-pencil-disabled">
                <img src="@/assets/images/icon-pencil.svg" class="w-100 p-2" />
              </router-link>
            </div>
          </div>
        </div>

        <div v-if="
          this.$store.state.REQUEST_CERT.CERT_THI.SUCCEED ||
          this.$store.state.REQUEST_CERT.CERT_ENG.SUCCEED ||
          this.$store.state.REQUEST_CERT.CERT_ENG_2YEAR.SUCCEED ||
          this.$store.state.REQUEST_CERT.CERT_ENG_1YEAR.SUCCEED
        " class="row mb-3 mt-2">
          <div class="col-6 col-lg-6">
            <button type="button" class="btn btn-light btn-cancel font-family d-inline-block" data-bs-toggle="modal"
              data-bs-target="#exampleModal">
              ยกเลิก
            </button>
          </div>
          <div class="col-6 col-lg-6 text-right">
            <div v-if="
              this.$store.state.REQUEST_CERT.CERT_ENG.SUCCEED ||
              this.$store.state.REQUEST_CERT.CERT_ENG_2YEAR.SUCCEED ||
              this.$store.state.REQUEST_CERT.CERT_ENG_1YEAR.SUCCEED
            ">
              <button type="button" class="btn btn-continue font-family d-inline-block" data-bs-toggle="modal"
                data-bs-target="#staticBackdrop">แนบเอกสาร</button>
            </div>
            <div v-else>
              <button type="button" class="btn btn-continue font-family d-inline-block"
                @click="Submit()">ส่งข้อมูล</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div v-if="this.Loading">
    <LoadingBs5></LoadingBs5>
  </div>

  <!-- Modal -->
  <div class="modal fade font-family" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel"
    aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title fs-4" id="exampleModalLabel"></h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="icon-model">
            <img src="@/assets/images/icon-warning.svg" class="w-100" />
          </div>
          <div class="massege fw-normal text-center">
            <p class="mb-0">รายการเปลี่ยนแปลงของท่านยังไม่ได้รับ</p>
            <p class="mb-0">การบันทึก และข้อมูลที่ท่านกรอกจะถูกล้าง</p>
            <p class="mb-0 pt-lg-4">
              ท่านต้องการจะย้อนกลับไปก่อนหน้านี้ใช่หรือไม่
            </p>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-light fw-normal popup_cancel " data-bs-dismiss="modal">
            ไม่ต้องการ
          </button>
          <router-link to="/AgenteService">
            <button type="button" class="btn btn-model fw-normal" data-bs-dismiss="modal"
              @click="ClearData()">ต้องการ</button>
          </router-link>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal -->
  <div class="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
    aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content font-family">
        <div class="modal-header">
          <h1 class="modal-title fs-4 blue-1" id="staticBackdropLabel">
            กรุณาแนบหลักฐาน
          </h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
            @click="ClearFile()"></button>
        </div>
        <div class="modal-body fw-normal fs-5">
          <div class="gray-3">ท่านได้ทำการขอเปลี่ยนแปลงรายการข้อมูลดังนี้</div>
          <div class="blue-1 ms-2">
            <img src="@/assets/images/icon-checked.svg" class="mb-1 pe-1"
              style="width: 25px; border-radius: 50%; cursor: pointer" />ขอหนังสือรับรองการทำงาน
          </div>
          <div>
            <label>กรุณากด</label><label
              class="blue-1 ps-1 pe-1">"แนบไฟล์"</label><label>เพื่อแนบหลักฐานการเปลี่ยนแปลงดังต่อไปนี้</label>
          </div>
          <div class="ps-2">
            <ul>
              <li v-if="this.$store.state.User_AG_LEVEL >= '04'" class="ps-2 blue-1">บันทึกขอหนังสือรับรองการทำงาน
                โดยผ่านความเห็นชอบจากหน่วยต้นสังกัด</li>
              <li class="ps-2 blue-1">สำเนา Passport</li>
            </ul>
          </div>
          <div>
            <label>(ประเภทไฟล์ jpg / jpeg / png / pdf / ขนาดไม่เกิน 4 MB)</label>
          </div>
          <div v-if="this.$store.state.User_AG_LEVEL >= '04'" class="shadow-none p-3 mb-1 bg-light rounded">
            <div class="text-center">
              <label class="fs-5 fw-normal">แนบไฟล์ บันทึกขอหนังสือรับรองการทำงาน
                โดยผ่านความเห็นชอบจากหน่วยต้นสังกัด</label>
              <button type="button" class="border-0 bg-light" @click="FileImportOne($event)">
                <a class="fs-5 blue-1">แนบไฟล์</a>
              </button>
              <input type="file" ref="UPLOADER_ONE" style="display: none" @change="onFileChangeOne($event)" />
            </div>
            <div v-if="this.UploadFile != null" class="row alert text-bg-success mt-1" role="alert">
              <div class="col-6 text-truncate">
                {{ File.name }}
              </div>
              <div class="col-6 text-center">Upload complete</div>
              <font-awesome-icon :icon="faCircleXmark"
                style="width: 25px; height: 30px; position: absolute; right: 3px; cursor: pointer;"
                @click="DelectFileOne()" />
            </div>
          </div>
          <div class="shadow-none p-3 mb-1 bg-light rounded">
            <div class="text-center">
              <label class="fs-5 fw-normal">แนบไฟล์ สำเนา Passport</label>
              <button type="button" class="border-0 bg-light" @click="FileImportTwe($event)">
                <a class="fs-5 blue-1">แนบไฟล์</a>
              </button>
              <input type="file" ref="UPLOADER_TWE" style="display: none" @change="onFileChangeTwe($event)" />
            </div>
            <div v-if="this.UploadFileTwe != null" class="row alert text-bg-success mt-1" role="alert">
              <div class="col-6 text-truncate">
                {{ FileTwe.name }}
              </div>
              <div class="col-6 text-center">Upload complete</div>
              <font-awesome-icon :icon="faCircleXmark"
                style="width: 25px; height: 30px; position: absolute; right: 3px; cursor: pointer;"
                @click="DelectFileTwe()" />
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary fs-5" data-bs-dismiss="modal" @click="ClearFile()">
            แก้ไข
          </button>
          <button type="button" class="btn btn-primary fs-5" data-bs-dismiss="modal" @click="CheckEnter()">
            ส่งข้อมูล
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Menu from "@/components/agenteservice/Menu.vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faCircleXmark } from "@fortawesome/free-solid-svg-icons";

import LoadingBs5 from "@/components/frontend/LoadingBs5";
import http from "@/services/AuthService";
import Swal from 'sweetalert2/src/sweetalert2.js'

export default {
  name: "RequestCertView",
  components: {
    Menu,
    FontAwesomeIcon,
    LoadingBs5
  },
  data() {
    return {
      faCircleXmark: faCircleXmark,
      Loading: true,
      UploadFile: null,
      File: '',
      UploadFileTwe: null,
      FileTwe: '',
      show: false,
    };
  },
  mounted() {
    if (this.$store.state.AgentCode == '') {
      this.$router.push('/');
    }

    // let AuthorizeToken = this.$cookies.get("AuthorizeToken");
    let AuthorizeToken = localStorage.getItem("AuthorizeToken");
    http.get("AgencyERequest/GetName?", { headers: { Authorization: `Bearer ${AuthorizeToken}` } }).then((res) => {
      if (res.status == 200) {
        this.$store.state.UserName = res.data.NAME + " " + res.data.SURNAME;
        this.$store.state.User_AG_LEVEL = res.data.AG_LEVEL;
        this.Loading = false;
      }
      else {
        this.Loading = false;
        localStorage.removeItem("Token");
        localStorage.removeItem("AuthorizeToken");
        window.open(process.env.VUE_APP_URL_ADFS + "AgencyERequestConvertor", '_self');
      }
    }).catch((error) => {
      this.Loading = false;
      Swal.fire({
        icon: 'error',
        html: '<label class="fs-4 fw-normal font-family">' + error.response.data.ErrorMessage + '</label>',
      }).then(() => {
        localStorage.removeItem("Token");
        localStorage.removeItem("AuthorizeToken");
        window.open(process.env.VUE_APP_URL_ADFS + "AgencyERequestConvertor/Logout", '_self');
      });
    });
  },
  methods: {
    FileImportOne(e) {
      this.$refs.UPLOADER_ONE.click();
    },
    onFileChangeOne(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (files[0].size > 1024 * 1024 * 4) {
        Swal.fire({
          icon: 'error',
          html: '<label class="fs-4 fw-normal font-family">กรุณาแบบไฟล์ที่มีขนาดไม่เกิน 4 MB</label>',
        });
      }
      else if (!this.ValidateFileType(files[0].type)) {
        Swal.fire({
          icon: 'error',
          html: '<label class="fs-4 fw-normal font-family">กรุณาแบบไฟล์ประเภท jpg / jpeg / png / pdf</label>',
        });
      }
      else {
        this.UploadFile = files[0];
        if (this.UploadFile != undefined || this.UploadFile != null) {
          const reader = new FileReader();
          reader.onload = () => {
            this.$store.state.REQUEST_CERT.CERT_ENG.FILE.FILE = reader.result.replace("data:", "").replace(/^.+,/, "");
            this.$store.state.REQUEST_CERT.CERT_ENG_1YEAR.FILE.FILE = reader.result.replace("data:", "").replace(/^.+,/, "");
            this.$store.state.REQUEST_CERT.CERT_ENG_2YEAR.FILE.FILE = reader.result.replace("data:", "").replace(/^.+,/, "");
          };
          reader.readAsDataURL(this.UploadFile);

          this.$store.state.REQUEST_CERT.CERT_ENG.FILE.FILE_TYPE = this.UploadFile.type;
          this.$store.state.REQUEST_CERT.CERT_ENG_1YEAR.FILE.FILE_TYPE = this.UploadFile.type;
          this.$store.state.REQUEST_CERT.CERT_ENG_2YEAR.FILE.FILE_TYPE = this.UploadFile.type;
          this.File = this.UploadFile;
        }
      }
    },
    DelectFileOne() {
      this.UploadFile = null;
      this.File = '';
      this.$store.state.REQUEST_CERT.CERT_ENG.FILE.FILE = '';
      this.$store.state.REQUEST_CERT.CERT_ENG.FILE.FILE_TYPE = '';
      this.$store.state.REQUEST_CERT.CERT_ENG_1YEAR.FILE.FILE = '';
      this.$store.state.REQUEST_CERT.CERT_ENG_1YEAR.FILE.FILE_TYPE = '';
      this.$store.state.REQUEST_CERT.CERT_ENG_2YEAR.FILE.FILE = '';
      this.$store.state.REQUEST_CERT.CERT_ENG_2YEAR.FILE.FILE_TYPE = '';

      this.$refs.UPLOADER_ONE.value = null;
    },
    FileImportTwe(e) {
      this.$refs.UPLOADER_TWE.click();
    },
    onFileChangeTwe(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (files[0].size > 1024 * 1024 * 4) {
        Swal.fire({
          icon: 'error',
          html: '<label class="fs-4 fw-normal font-family">กรุณาแบบไฟล์ที่มีขนาดไม่เกิน 4 MB</label>',
        });
      }
      else if (!this.ValidateFileType(files[0].type)) {
        Swal.fire({
          icon: 'error',
          html: '<label class="fs-4 fw-normal font-family">กรุณาแบบไฟล์ประเภท jpg / jpeg / png / pdf</label>',
        });
      }
      else {
        this.UploadFileTwe = files[0];
        if (this.UploadFileTwe != undefined || this.UploadFileTwe != null) {
          const reader = new FileReader();
          reader.onload = () => {
            this.$store.state.REQUEST_CERT.CERT_ENG.FILE_PASSPORT.FILE = reader.result.replace("data:", "").replace(/^.+,/, "");
            this.$store.state.REQUEST_CERT.CERT_ENG_1YEAR.FILE_PASSPORT.FILE = reader.result.replace("data:", "").replace(/^.+,/, "");
            this.$store.state.REQUEST_CERT.CERT_ENG_2YEAR.FILE_PASSPORT.FILE = reader.result.replace("data:", "").replace(/^.+,/, "");
          };
          reader.readAsDataURL(this.UploadFileTwe);

          this.$store.state.REQUEST_CERT.CERT_ENG.FILE_PASSPORT.FILE_TYPE = this.UploadFileTwe.type;
          this.$store.state.REQUEST_CERT.CERT_ENG_1YEAR.FILE_PASSPORT.FILE_TYPE = this.UploadFileTwe.type;
          this.$store.state.REQUEST_CERT.CERT_ENG_2YEAR.FILE_PASSPORT.FILE_TYPE = this.UploadFileTwe.type;

          this.FileTwe = this.UploadFileTwe;
        }
      }
    },
    DelectFileTwe() {
      this.UploadFileTwe = null;
      this.FileETwe = '';
      this.$store.state.REQUEST_CERT.CERT_ENG.FILE_PASSPORT.FILE = '';
      this.$store.state.REQUEST_CERT.CERT_ENG.FILE_PASSPORT.FILE_TYPE = '';
      this.$store.state.REQUEST_CERT.CERT_ENG_1YEAR.FILE_PASSPORT.FILE = '';
      this.$store.state.REQUEST_CERT.CERT_ENG_1YEAR.FILE_PASSPORT.FILE_TYPE = '';
      this.$store.state.REQUEST_CERT.CERT_ENG_2YEAR.FILE_PASSPORT.FILE = '';
      this.$store.state.REQUEST_CERT.CERT_ENG_2YEAR.FILE_PASSPORT.FILE_TYPE = '';

      this.$refs.UPLOADER_TWE.value = null;
    },
    Submit() {
      this.Loading = true;
      this.$store.state.REQUEST_CERT.AGENTCODE = this.$store.state.AgentCode;
      // let AuthorizeToken = this.$cookies.get("AuthorizeToken");
      let AuthorizeToken = localStorage.getItem("AuthorizeToken");
      http.post("AgencyERequest/RequestCert", this.$store.state.REQUEST_CERT, { headers: { Authorization: `Bearer ${AuthorizeToken}` } }).then((res) => {
        if (res.status == 200) {
          this.Loading = false;
          Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'ส่งข้อมูลสำเร็จ',
            showConfirmButton: false,
            timer: 1500
          }).then(() => {
            this.ClearData();

            // this.$router.push('/FinishAgentInfoView');
            this.$router.push({
              path: '/FinishAgentInfoView',
              query: { tel: '8553' }
            });
          });
        }
        else {
          Swal.fire({
            icon: 'error',
            html: '<label class="fs-4 fw-normal font-family">ส่งข้อมูลไม่สำเร็จ</label>',
          });
        }
      }).catch((error) => {
        Swal.fire({
          icon: 'error',
          html: '<label class="fs-4 fw-normal font-family">ส่งข้อมูลไม่สำเร็จ</label>',
        });
      });
    },
    CheckEnter() {
      let LEVEL = parseInt(this.$store.state.User_AG_LEVEL);
      if (LEVEL >= 4 && (this.UploadFile == '' || this.UploadFile == null)) {
        Swal.fire({
          icon: 'error',
          html: '<label class="fs-4 fw-normal font-family">กรุณาแนบไฟล์ บันทึกขอหนังสือรับรองการทำงานโดยผ่านความเห็นชอบจากหน่วยต้นสังกัดตรง</label>',
        });
      }
      else if (this.UploadFileTwe == '' || this.UploadFileTwe == null) {
        Swal.fire({
          icon: 'error',
          html: '<label class="fs-4 fw-normal font-family">กรุณาแนบไฟล์ สำเนา Passport</label>',
        });
      }
      else {
        this.Loading = true;
        this.$store.state.REQUEST_CERT.AGENTCODE = this.$store.state.AgentCode;
        // let AuthorizeToken = this.$cookies.get("AuthorizeToken");
        let AuthorizeToken = localStorage.getItem("AuthorizeToken");
        http.post("AgencyERequest/RequestCert", this.$store.state.REQUEST_CERT, { headers: { Authorization: `Bearer ${AuthorizeToken}` } }).then((res) => {
          if (res.status == 200) {
            this.Loading = false;
            Swal.fire({
              position: 'center',
              icon: 'success',
              title: 'ส่งข้อมูลสำเร็จ',
              showConfirmButton: false,
              timer: 1500
            }).then(() => {
              this.ClearData();

              // this.$router.push('/FinishAgentInfoView');
              this.$router.push({
                path: '/FinishAgentInfoView',
                query: { tel: '8553' }
              });
            });
          }
          else {
            Swal.fire({
              icon: 'error',
              html: '<label class="fs-4 fw-normal font-family">ส่งข้อมูลไม่สำเร็จ</label>',
            });
          }
        }).catch((error) => {
          Swal.fire({
            icon: 'error',
            html: '<label class="fs-4 fw-normal font-family">ส่งข้อมูลไม่สำเร็จ</label>',
          });
        });
      }
    },
    ClearData() {
      this.$store.state.REQUEST_CERT.CERT_THI.REASON_DTL = '';
      this.$store.state.REQUEST_CERT.CERT_THI.YEAR = '';
      this.$store.state.REQUEST_CERT.CERT_THI.SUCCEED = false;

      this.$store.state.REQUEST_CERT.CERT_ENG.REASON_DTL = '';
      this.$store.state.REQUEST_CERT.CERT_ENG.YEAR = '';
      this.$store.state.REQUEST_CERT.CERT_ENG.SUCCEED = false;
      this.$store.state.REQUEST_CERT.CERT_ENG.FILE.FILE = '';
      this.$store.state.REQUEST_CERT.CERT_ENG.FILE.FILE_TYPE = '';
      this.$store.state.REQUEST_CERT.CERT_ENG.FILE_PASSPORT.FILE = '';
      this.$store.state.REQUEST_CERT.CERT_ENG.FILE_PASSPORT.FILE_TYPE = '';

      this.$store.state.REQUEST_CERT.CERT_ENG_1YEAR.REASON_DTL = '';
      this.$store.state.REQUEST_CERT.CERT_ENG_1YEAR.YEAR = '';
      this.$store.state.REQUEST_CERT.CERT_ENG_1YEAR.SUCCEED = false;
      this.$store.state.REQUEST_CERT.CERT_ENG_1YEAR.FILE.FILE = '';
      this.$store.state.REQUEST_CERT.CERT_ENG_1YEAR.FILE.FILE_TYPE = '';
      this.$store.state.REQUEST_CERT.CERT_ENG_1YEAR.FILE_PASSPORT.FILE = '';
      this.$store.state.REQUEST_CERT.CERT_ENG_1YEAR.FILE_PASSPORT.FILE_TYPE = '';

      this.$store.state.REQUEST_CERT.CERT_ENG_2YEAR.REASON_DTL = '';
      this.$store.state.REQUEST_CERT.CERT_ENG_2YEAR.YEAR = '';
      this.$store.state.REQUEST_CERT.CERT_ENG_2YEAR.SUCCEED = false;
      this.$store.state.REQUEST_CERT.CERT_ENG_2YEAR.FILE.FILE = '';
      this.$store.state.REQUEST_CERT.CERT_ENG_2YEAR.FILE.FILE_TYPE = '';
      this.$store.state.REQUEST_CERT.CERT_ENG_2YEAR.FILE_PASSPORT.FILE = '';
      this.$store.state.REQUEST_CERT.CERT_ENG_2YEAR.FILE_PASSPORT.FILE_TYPE = '';

      this.$store.state.CheckCertYear = '';
    },
    ClearFile() {
      this.$store.state.REQUEST_CERT.CERT_ENG.FILE.FILE = '';
      this.$store.state.REQUEST_CERT.CERT_ENG.FILE.FILE_TYPE = '';
      this.$store.state.REQUEST_CERT.CERT_ENG.FILE_PASSPORT.FILE = '';
      this.$store.state.REQUEST_CERT.CERT_ENG.FILE_PASSPORT.FILE_TYPE = '';

      this.$store.state.REQUEST_CERT.CERT_ENG_1YEAR.FILE.FILE = '';
      this.$store.state.REQUEST_CERT.CERT_ENG_1YEAR.FILE.FILE_TYPE = '';
      this.$store.state.REQUEST_CERT.CERT_ENG_1YEAR.FILE_PASSPORT.FILE = '';
      this.$store.state.REQUEST_CERT.CERT_ENG_1YEAR.FILE_PASSPORT.FILE_TYPE = '';

      this.$store.state.REQUEST_CERT.CERT_ENG_2YEAR.FILE.FILE = '';
      this.$store.state.REQUEST_CERT.CERT_ENG_2YEAR.FILE.FILE_TYPE = '';
      this.$store.state.REQUEST_CERT.CERT_ENG_2YEAR.FILE_PASSPORT.FILE = '';
      this.$store.state.REQUEST_CERT.CERT_ENG_2YEAR.FILE_PASSPORT.FILE_TYPE = '';
    },
    ChechCreateJob(To, SUBJOB) {
      // let AuthorizeToken = this.$cookies.get("AuthorizeToken");
      let AuthorizeToken = localStorage.getItem("AuthorizeToken");
      let request = {
        AGENTCODE: [],
        SUBJOB: SUBJOB
      };

      http.post("AgencyERequest/CheckCreateJob?", request, { headers: { Authorization: `Bearer ${AuthorizeToken}` } }).then((res) => {
        if (res.status == 200) {
          if (res.data !== '001' && res.data !== '002') {
            this.$router.push(To);
          }
          else {
            Swal.fire({
              icon: 'error',
              html: '<label class="fs-4 fw-normal font-family">ไม่สามารถทำรายการนี้ได้ เนื่องจากมีการร้องของานไปแล้วก่อนหน้า</label>',
            });

            this.$router.push("/AgenteService");
          }
        }
      }).catch((error) => { });
    },
    ValidateFileType(Type) {
      if (Type !== "image/png" && Type !== "image/jpeg" && Type !== "application/pdf" && Type !== "image/jpg") {
        this.ClearFile();
        return false;
      }
      else {
        return true;
      }
    }
  },
};
</script>

<style>
.icon-pencil-disabled {
  position: absolute;
  right: 0px;
  width: 30px;
  border-radius: 50%;
  background: #dddddd !important;
  color: #dddddd !important;
  cursor: inherit !important;
}
</style>